import {
  Button,
  Card,
  Container,
  Divider,
  FormControl,
  Grid,
  InputAdornment,
  ListSubheader,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useState
} from 'react';
import { useNavigate } from 'react-router';
import PageTitleWrapper from 'src/components/PageTitleWrapper';
import { AddProject } from 'src/models/project_details';
import {
  getAllCustomers,
  getCountries,
  getExternalLeads,
  getSegments,
  getStakeholdersById
} from 'src/services/projectService';
import { useForm } from 'react-hook-form';
import {
  AddProjectDetail,
  getProjectBilling,
  getProjectNature,
  getProjectStatus,
  getSalesStage
} from 'src/services/projectDetailService';
import { getAllEmployees, getJiraLeadEmployees } from 'src/services/employeeService';
import CancelIcon from '@mui/icons-material/Cancel';
import SnackBar from 'src/components/SnackBar/SnackBar';
import ConfirmationModal from '../common/confirmationModal/ConfirmationModal';
import ToggleModalStakeholder from '../stakeholders/ToggleModal';
import ToggleModalCustomer from '../clients/ToggleModal';
import SearchIcon from '@mui/icons-material/Search';
import moment from 'moment';
import ToggleModalExternalsAdd from './components/Others/ToggleModalExternalsAdd';
import { useDispatch } from 'react-redux';
import { AppActions } from 'src/store/AppReducer';
import { useAppSelector } from 'src/hooks/hooks';
import { getStakeholderRole } from '../../services/projectDetailService';
import { DatePicker } from '@mui/lab';
import 'src/content/projectDetails/ProjectDetails.css';

const ProjectCreatePage = () => {
  const navigate = useNavigate();

  const { register, handleSubmit, reset, setValue, getValues } =
    useForm<AddProject>();

  const TextFieldStyle = {
    marginTop: 5,
    paddingLeft: 15,
    paddingRight: 9,
    fontSize: '13px'
  };

  const LabelStyle = {
    paddingLeft: 15,
    paddingRight: 15,
    fontSize: '13px'
  };

  const selectStyle = {
    width: '94%',
    marginLeft: 15,
    marginTop: 5,
    paddingRight: 15,
    fontSize: '13px'
  };

  const [isStakeholderName, isSetStakeholderName] = useState(false);
  const [isStakeholderRole, isSetStakeholderRole] = useState(false);

  const [customers, setCustomers] = useState<any>([]);
  const [stakeholders, setStakeholders] = useState<any>([]);
  const [selectedStakeholder, setSelectedStakeholder] = useState('');
  const [selectedRole, setSelectedRole] = useState('');
  const [stakeholderRoles, setStakeholderRoles] = useState<any>([]);

  const getCustomerData = () => {
    getAllCustomers().then((res) => {
      setCustomers(res.data);
    });
  };

  useEffect(() => {
    getCustomerData();
  }, []);

  const [projectObj, setProjectObj] = useState<AddProject>({
    customerId: '',
    type: '',
    key: '',
    name: '',
    nature: '',
    //leadResourceType: '',
    //leadResourceId: '',
    //leadResourceName: '',
    projectLeadId: '',
    projectStatus: '',
    salesStage: '',
    billingCategory: '',
    sowStatus: '',
    poStatus: '',
    noteForInvoice: '',
    projectStakeHolders: [],
    plannedHours: 0,
    preSalesStartDate: '',
    preSalesEndDate: '',
    plannedStartDate: '',
    plannedEndDate: ''
  });

  const [projectErrors, setProjectErrors] = useState({
    customerIdError: '',
    typeError: '',
    keyError: '',
    nameError: '',
    natureError: '',
    //leadResourceTypeError: '',
    //leadResourceIdError: '',
    //leadResourceNameError: '',
    projectLeadIdError: '',
    projectStatusError: '',
    salesStageError: '',
    billingCategoryError: '',
    sowStatusError: '',
    poStatusError: '',
    invoiceNoteError: '',
    projectStakeHoldersError: '',
    plannedHoursError: '',
    preSalesStartDateError: '',
    preSalesEndDateError: '',
    plannedStartDateError: '',
    plannedEndDateError: '',
    stakeholderDuplicate: '',
  });

  const [stakeholderError, setStakeholderError] = useState('');

  const [projectStakeholderError, setProjectStakeholderError] = useState('');
  const [projectStakeholderRoleError, setProjectStakeholderRoleError] = useState('');

  const getStakeholderData = useCallback(() => {
    getStakeholdersById(projectObj.customerId).then((res) => {
      setStakeholders(res.data);
    });
  }, [projectObj.customerId]);

  const getStakeholderRoleData = useCallback(() => {
    getStakeholderRole().then((res) => {
       setStakeholderRoles(res.data);
      });
  }, []);

  useEffect(() => {
    getStakeholderRoleData();
  }, [getStakeholderRoleData]);

  useEffect(() => {
    getStakeholderData();
  }, [getStakeholderData, projectObj]);

  const [snackBarOpen, setSnackBarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState('');
  const [snackBarMessage, setSnackBarMessage] = useState('');

  const checkTrimmed = (value) => {
    if (typeof value === 'string') {
      return value?.trim()?.length < 1 ? true : false;
    } else {
      return false;
    }
  };

  const dispatch = useDispatch();

  const { isLoading } = useAppSelector((state) => state.appReducer);

  const onSubmit = () => {
    const errorsObj: any = {};
    let allData: AddProject = projectObj;
    if (projectObj.type === 'Delivery') {
      delete allData.salesStage;
      delete allData.preSalesStartDate;
      delete allData.preSalesEndDate;
    }
    if (projectObj.type === 'Pre-sale') {
      delete allData.plannedEndDate;
      delete allData.plannedStartDate;
    }

    for (const [key, value] of Object.entries(allData)) {
      if (
        (value === '' ||
          value?.length === 0 ||
          value === 0 ||
          checkTrimmed(value)) &&
        key !== 'noteForInvoice' &&
        key !== 'billingCategory'
      ) {
        errorsObj[`${key}Error`] = `${key} Required`;
      }
    }

    setProjectErrors(errorsObj);

    if (Object.keys(errorsObj)?.length === 0) {
      dispatch(AppActions.showLoader());

      AddProjectDetail(allData)
        .then(() => {
          dispatch(
            AppActions.toggleSnackBarOpen({
              message: 'You’ve created a project successfully.',
              severity: 'success'
            })
          );
          setSnackBarOpen(true);
          toggleConfirmation();
          clearData();
          dispatch(AppActions.hideLoader());
          setTimeout(() => {
            navigate('/project-details');
          }, 1000);
        })
        .catch((e) => {
          setSnackBarMessage(e.response.data ? e.response.data : 'Unable to create the project');
          setSnackbarSeverity('error');
          toggleConfirmation();
          dispatch(AppActions.hideLoader());
          setSnackBarOpen(true);
        });
    }
  };

  const onlyAlphanumericRegex = /[^a-z0-9]/gi;

  const [billingCategories, setBillingCategories] = useState([]);
  const [projectNatures, setProjectNatures] = useState([]);
  const [projectStatus, setProjectStatus] = useState([]);
  const [externalLeads, setExternalLeads] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [selectedStakeholders, setSelectedStakeholders] = useState([]);
  const [jiraLeadEmployees, setJiraLeadEmployees] = useState([]);
  const [saleStages, setSaleStages] = useState([]);

  const getAllExternalLeads = () => {
    getExternalLeads().then((res) => {
      setExternalLeads(res.data);
    });
  };

  const getAllMasterData = () => {
    getProjectBilling().then((res) => {
      const billingNames = res?.data?.map((dat) => {
        return {
          title: dat.name
        };
      });

      setBillingCategories(billingNames || []);
    });

    getProjectNature().then((res) => {
      const natureNames = res?.data?.map((dat) => {
        return {
          title: dat.name
        };
      });

      setProjectNatures(natureNames || []);
    });

    getProjectStatus().then((res) => {
      const statusNames = res?.data?.map((dat) => {
        return {
          title: dat.name
        };
      });

      setProjectStatus(statusNames || []);
    });

    getExternalLeads().then((res) => {
      setExternalLeads(res.data);
    });

    getAllEmployees().then((res) => {
      setEmployees(res.data);
    });

    getJiraLeadEmployees().then((res) => {
      setJiraLeadEmployees(res.data);
    })

    getSalesStage().then((res) => {
      const preSaleStages = res?.data?.map((dat) => {
        return {
          title: dat.name
        };
      });

      setSaleStages(preSaleStages || []);
    });
  };

  useEffect(() => {
    getAllMasterData();
  }, []);

  const [openConfirmation, setOpenConfirmation] = useState(false);

  const toggleConfirmation = () => {
    if (openConfirmation) {
      setOpenConfirmation(!openConfirmation);
    }

    const errorsObj: any = {};
    let allData: AddProject = projectObj;

    if (projectObj.type === 'Delivery') {
      delete allData.salesStage;
      delete allData.preSalesStartDate;
      delete allData.preSalesEndDate;
    }
    if (projectObj.type === 'Pre-sale') {
      delete allData.plannedEndDate;
      delete allData.plannedStartDate;
    }
    if(!selectedStakeholder) {
      if(!(projectObj.projectStakeHolders.length > 0)) {
        setProjectStakeholderError('Project Stakeholder Name Required');
      }else{
        setProjectStakeholderError('');
      }
    }
    if(!selectedRole){
      if(!(projectObj.projectStakeHolders.length > 0)) {
        setProjectStakeholderRoleError('Project Stakeholder Role Required');
      }else{
        setProjectStakeholderRoleError('');
      }
    }
    if(!(projectObj.projectStakeHolders.length > 0)) {
      setStakeholderError('Project Stakeholder is Required')
    }
    if(!allData.customerId) {
      errorsObj.customerIdError = 'Client is Required'
    }
    if(!allData.type) {
      errorsObj.typeError = 'Project Type is Required'
    }
    if(!allData.name) {
      errorsObj.nameError = 'Project Name is Required'
    }
    if(!allData.key) {
      errorsObj.keyError = 'Project Code is Required'
    }
    if(!allData.nature) {
      errorsObj.natureError = 'Project Nature is Required'
    }
    if(!allData.projectStatus) {
      errorsObj.projectStatusError = 'Project Status is Required'
    }
    /* if(!allData.leadResourceType) {
      errorsObj.leadResourceTypeError = 'Engagement Lead Type is Required'
    } */
    /* if(!allData.leadResourceName) {
      errorsObj.leadResourceNameError = 'Engagement Lead is Required'
    } */
    if(!allData.projectLeadId) {
      errorsObj.projectLeadIdError = 'Project Lead is Required'
    }
    if(!allData.salesStage) {
      errorsObj.salesStageError = 'Pre-sale Stage is Required'
    }
    if(!allData.billingCategory) {
      errorsObj.billingCategoryError = 'Billing Category is Required'
    }
    if(!allData.sowStatus) {
      errorsObj.sowStatusError = 'SOW Status is Required'
    }
    if(!allData.poStatus) {
      errorsObj.poStatusError = 'PO Status is Required'
    }
    if(!allData.plannedHours) {
      errorsObj.plannedHoursError = 'Planned Hours is Required'
    }
    if(!allData.preSalesStartDate) {
      errorsObj.preSalesStartDateError = 'Pre-sale Start Date is Required'
    }
    if(!allData.preSalesEndDate) {
      errorsObj.preSalesEndDateError = 'Pre-sale End Date is Required'
    }
    if(!allData.plannedStartDate) {
      errorsObj.plannedStartDateError = 'Planned Start Date is Required'
    }
    if(!allData.plannedEndDate) {
      errorsObj.plannedEndDateError = 'Planned End Date is Required'
    }
    setProjectErrors(errorsObj);

    if (
      allData.customerId &&
      allData.type &&
      allData.name &&
      allData.key &&
      allData.nature &&
      allData.projectStatus &&
      //allData.leadResourceType &&
      //allData.leadResourceName &&
      allData.projectLeadId &&
      allData.billingCategory &&
      allData.sowStatus &&
      allData.poStatus &&
      allData.plannedHours &&
      projectObj.projectStakeHolders.length >= 1
    ) {
      if (
        allData.type === 'Pre-sale' &&
        allData.salesStage &&
        allData.preSalesStartDate &&
        allData.preSalesEndDate
      ) {
        setOpenConfirmation(!openConfirmation);
      }
      if (
        allData.type === 'Delivery' &&
        allData.plannedStartDate &&
        allData.plannedEndDate
      ) {
        setOpenConfirmation(!openConfirmation);
      }
    }
  };

  const clearData = () => {
    setProjectObj({
      customerId: '',
      type: '',
      key: '',
      name: '',
      nature: '',
      //leadResourceType: '',
      //leadResourceId: '',
      //leadResourceName: '',
      projectLeadId: '',
      projectStatus: '',
      salesStage: '',
      billingCategory: '',
      sowStatus: '',
      poStatus: '',
      noteForInvoice: '',
      projectStakeHolders: [],
      plannedHours: 0,
      preSalesStartDate: '',
      preSalesEndDate: '',
      plannedStartDate: '',
      plannedEndDate: ''
    });
    setProjectErrors({
      customerIdError: '',
      typeError: '',
      keyError: '',
      nameError: '',
      natureError: '',
      //leadResourceTypeError: '',
      //leadResourceIdError: '',
      //leadResourceNameError: '',
      projectLeadIdError: '',
      projectStatusError: '',
      salesStageError: '',
      billingCategoryError: '',
      sowStatusError: '',
      poStatusError: '',
      invoiceNoteError: '',
      projectStakeHoldersError: '',
      plannedHoursError: '',
      preSalesStartDateError: '',
      preSalesEndDateError: '',
      plannedStartDateError: '',
      plannedEndDateError: '',
      stakeholderDuplicate: '',
    });
    setStakeholderError('');
    navigate('/project-details');
  };

  const [openStakeHolders, setOpenStakeHolders] = useState(false);
  const [openExternals, setOpenExternals] = useState(false);
  const [openCustomers, setOpenCustomers] = useState(false);
  const [segments, setSegments] = useState<any>([]);
  const [countries, setCountries] = useState([]);

  const getSegmentsCustomers = () => {
    getSegments().then((res) => {
      setSegments(res.data);
    });
  };

  const toggleExternalsAdd = () => {
    setOpenExternals(!openExternals);
  };

  const toggleCustomersAdd = () => {
    setOpenCustomers(!openCustomers);
  };

  const toggleStakeholdersAdd = () => {
    setOpenStakeHolders(!openStakeHolders);
  };

  useEffect(() => {
    getSegmentsCustomers();
    getCountries().then((res) => {
      const arr = res.data;
      const simplifiedArr = arr.map((con) => con?.name);
      const sortedData = simplifiedArr.sort((a, b) => a.localeCompare(b));
      setCountries(sortedData);
    });
  }, []);

  const containsText = (text, searchText) =>
    text.toLowerCase().indexOf(searchText.toLowerCase()) > -1;

  const [selectedOption, setSelectedOption] = useState('');
  const [searchText, setSearchText] = useState('');

  const displayedOptions = useMemo(
    () =>
      customers.length > 0 &&
      customers?.filter((option) => containsText(option.name, searchText)),
    [searchText, customers]
  );

  const displayedEnagagementLead = useMemo(
    () =>
      employees?.length > 0 &&
      employees?.filter((option) => containsText(option.name, searchText)),
    [searchText, employees]
  );

  const displayedEnagagementLeadExternal = useMemo(
    () =>
      externalLeads?.length > 0 &&
      externalLeads?.filter((option) => containsText(option.name, searchText)),
    [searchText, externalLeads]
  );

  const displayedProductLead = useMemo(
    () =>
      employees?.length > 0 &&
      employees?.filter((option) => containsText(option.name, searchText) && !option?.employeeFinance?.isResign),
    [searchText, employees]
  );

  const displayedStakeholderName = useMemo(
    () =>
    stakeholders?.length > 0 &&
    stakeholders?.filter((option) => containsText(option.name, searchText)),
    [searchText, stakeholders]
  );

  const displayedStakeholderRole = useMemo(
    () =>
    stakeholderRoles?.filter((option) => containsText(option.value, searchText)),
    [searchText, stakeholderRoles]
  );

  return (
    <Fragment>
      <Grid container direction={'row'}>
        <Grid container direction={'row'} sx={{ py: 2, px: 3 }}>
          <Grid item>
            <Typography
              id="breadcrumbs-project-details"
              onClick={() => {
                navigate('/project-details');
              }}
              style={{ cursor: 'pointer' }}
              variant="h4"
              component="h4"
            >
              {' '}
              Project Details /
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              style={{ fontWeight: 'normal' }}
              variant="h4"
              component="h4"
            >
              &nbsp;Create New
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Container maxWidth="xl">
        <Card style={{ paddingBottom: '2rem' }}>
          <Grid item xs={12} sx={{ pt: 3, pb: 1, pl: 4, pr: 4 }}>
            <Typography style={{ fontSize: '15px' }} variant="h3">
              General Details
            </Typography>
          </Grid>
          <Grid container sx={{ pt: 2, pb: 1, pl: 2 }}>
            <Grid item xs={4}>
              <Grid
                style={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <Typography style={LabelStyle} fontWeight="light" variant="h5">
                  Client<span style={{ color: 'red' }}>*</span>
                </Typography>
                <Typography
                  id="btn-toggleCustomersAdd"
                  style={{
                    paddingLeft: 15,
                    paddingRight: 15,
                    fontSize: '11px',
                    color: '#0000EE',
                    cursor: 'pointer'
                  }}
                  fontWeight="light"
                  variant="h5"
                  onClick={() => toggleCustomersAdd()}
                >
                  Create New Client
                </Typography>
              </Grid>
              <Select
                MenuProps={{ autoFocus: false }}
                labelId="search-select-label"
                {...register('customerId', {})}
                style={{
                  height: '2.25rem',
                  width: '94%',
                  marginLeft: 15,
                  marginTop: 5,
                  paddingRight: 15,
                  fontSize: '13px'
                }}
                id="create-customerId"
                displayEmpty
                defaultValue=""
                value={selectedOption || ''}
                onChange={(e) => {
                  setSelectedOption(e.target.value);
                  setProjectObj((prev) => ({
                    ...prev,
                    customerId: e.target.value
                  }));
                  setProjectErrors((prev) => ({
                    ...prev,
                    customerIdError: ''
                  }));
                }}
                onClose={() => setSearchText('')}
              >
                <ListSubheader>
                  <TextField
                    id="search-create-customerId"
                    size="small"
                    autoFocus
                    placeholder="Type to search..."
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      )
                    }}
                    onChange={(e) => setSearchText(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key !== 'Escape') {
                        // Prevents autoselecting item while typing (default Select behaviour)
                        e.stopPropagation();
                      }
                    }}
                  />
                </ListSubheader>
                <MenuItem
                  style={{ display: 'none' }}
                  selected
                  disabled
                  value={''}
                >
                  Select Client
                </MenuItem>
                {displayedOptions.length > 0 &&
                  displayedOptions?.map((option, i) => (
                    <MenuItem key={i} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
              </Select>
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px',
                  textTransform: 'capitalize'
                }}
                color="red"
              >
                {projectErrors.customerIdError}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography style={LabelStyle} fontWeight="light" variant="h5">
                Project Type<span style={{ color: 'red' }}>*</span>
              </Typography>
              <Select
                id="create-type"
                className="select-text"
                size="small"
                style={selectStyle}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                {...register('type', {})}
                defaultValue={''}
                value={projectObj.type}
                onChange={(e) => {
                  setProjectObj((prev) => ({
                    ...prev,
                    type: e.target.value
                  }));
                  setProjectErrors((prev) => ({
                    ...prev,
                    typeError: ''
                  }));
                }}
              >
                <MenuItem
                  style={{ display: 'none' }}
                  selected
                  disabled
                  value={''}
                >
                  Select Project Type
                </MenuItem>
                <MenuItem value="Pre-sale">Pre-sale</MenuItem>
                <MenuItem value="Delivery">Delivery</MenuItem>
              </Select>
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px',
                  textTransform: 'capitalize'
                }}
                color="red"
              >
                {projectErrors.typeError}
              </Typography>
            </Grid>
            {projectObj.type === 'Pre-sale' && (
              <Grid item xs={4}>
                <Typography style={LabelStyle} fontWeight="light" variant="h5">
                  Pre-sale Stage
                  <span style={{ color: 'red' }}>*</span>
                </Typography>
                <Select
                  id="create-salesStage"
                  className="select-text"
                  size="small"
                  style={selectStyle}
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                  {...register('salesStage', {})}
                  defaultValue={''}
                  value={projectObj.salesStage}
                  onChange={(e) => {
                    setProjectObj((prev) => ({
                      ...prev,
                      salesStage: e.target.value
                    }));
                    setProjectErrors((prev) => ({
                      ...prev,
                      salesStageError: ''
                    }));
                  }}
                >
                  <MenuItem
                    style={{ display: 'none' }}
                    selected
                    disabled
                    value=""
                  >
                    Select Pre-sale Stage
                  </MenuItem>
                  {saleStages?.length > 0 &&
                  saleStages.map((item) => (
                    <MenuItem key={item.title} value={item.title}>
                      {item.title}
                    </MenuItem>
                  ))}
                </Select>
                <Typography
                  style={{
                    paddingLeft: 15,
                    paddingRight: 15,
                    fontSize: '11px',
                    textTransform: 'capitalize'
                  }}
                  color="red"
                >
                  {projectErrors.salesStageError}
                </Typography>
              </Grid>
            )}
            <Grid
              item
              xs={4}
              sx={{ pt: projectObj.type === 'Pre-sale' ? 3 : 0 }}
            >
              <Typography style={LabelStyle} fontWeight="light" variant="h5">
                Project Name <span style={{ color: 'red' }}>*</span>
              </Typography>
              <TextField
                id="create-name"
                size="small"
                className="input-text"
                style={TextFieldStyle}
                inputProps={{
                  style: {
                    height: '1.25rem',
                    fontSize: '13px'
                  }
                }}
                fullWidth
                placeholder="Enter Project Name"
                variant="outlined"
                {...register('name', {})}
                value={projectObj.name}
                onChange={(e) => {
                  if (!e.target.value) {
                    setProjectErrors((prev) => ({
                      ...prev,
                      nameError: 'Project Name Required'
                    }));
                  } else if (e.target.value.length > 30) {
                    setProjectErrors((prev) => ({
                      ...prev,
                      nameError: 'Character length should not exceed 30'
                    }));
                  } else if (e.target.value?.trim()?.length < 1) {
                    setProjectErrors((prev) => ({
                      ...prev,
                      nameError: 'Project Name cannot be only spaces'
                    }));
                  } else {
                    setProjectErrors((prev) => ({
                      ...prev,
                      nameError: ''
                    }));
                  }
                  setProjectObj((prev) => ({
                    ...prev,
                    name: e.target.value
                  }));
                }}
              />
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px',
                  textTransform: 'capitalize'
                }}
                color="red"
              >
                {projectErrors.nameError}
              </Typography>
            </Grid>
            <Grid item xs={4} sx={{ pt: 3 }}>
              <Typography style={LabelStyle} fontWeight="light" variant="h5">
                Project Code <span style={{ color: 'red' }}>*</span>
              </Typography>
              <TextField
                id="create-key"
                size="small"
                fullWidth
                className="input-text"
                style={TextFieldStyle}
                placeholder="Project Code"
                variant="outlined"
                inputProps={{
                  style: {
                    height: '1.25rem',
                    fontSize: '13px'
                  }
                }}
                {...register('key', {})}
                value={projectObj.key}
                onChange={(e) => {
                  e.target.value = e.target.value.replace(
                    onlyAlphanumericRegex,
                    ''
                  );

                  if (e.target.value.length > 20) {
                    setProjectErrors((prev) => ({
                      ...prev,
                      keyError: 'Character length should not exceed 20'
                    }));
                  } else {
                    setProjectErrors((prev) => ({
                      ...prev,
                      keyError: ''
                    }));
                  }
                  setProjectObj((prev) => ({
                    ...prev,
                    key: e.target.value
                  }));
                }}
              />
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px',
                  textTransform: 'capitalize'
                }}
                color="red"
              >
                {projectErrors.keyError}
              </Typography>
            </Grid>
            <Grid item xs={4} sx={{ pt: 3 }}>
              <Typography style={LabelStyle} fontWeight="light" variant="h5">
                Project Nature <span style={{ color: 'red' }}>*</span>
              </Typography>
              <Select
                id="create-nature"
                className="select-text"
                size="small"
                style={selectStyle}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                {...register('nature', {})}
                defaultValue={''}
                value={projectObj.nature}
                onChange={(e) => {
                  setProjectObj((prev) => ({
                    ...prev,
                    nature: e.target.value
                  }));
                  setValue('nature', e.target.value);
                  setProjectErrors((prev) => ({
                    ...prev,
                    natureError: ''
                  }));
                }}
              >
                <MenuItem
                  style={{ display: 'none' }}
                  selected
                  disabled
                  value=""
                >
                  Select Project Nature
                </MenuItem>
                {projectNatures?.length > 0 &&
                  projectNatures.map((nature) => (
                    <MenuItem key={nature.title} value={nature.title}>
                      {nature.title}
                    </MenuItem>
                  ))}
              </Select>
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px',
                  textTransform: 'capitalize'
                }}
                color="red"
              >
                {projectErrors.natureError}
              </Typography>
            </Grid>
            <Grid item xs={4} sx={{ pt: 3 }}>
              <Typography style={LabelStyle} fontWeight="light" variant="h5">
                Project Status
                <span style={{ color: 'red' }}>*</span>
              </Typography>
              <Select
                id="create-projectStatus"
                className="select-text"
                size="small"
                style={selectStyle}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                {...register('projectStatus', {})}
                defaultValue={''}
                value={projectObj.projectStatus}
                onChange={(e) => {
                  setProjectObj((prev) => ({
                    ...prev,
                    projectStatus: e.target.value
                  }));
                  setProjectErrors((prev) => ({
                    ...prev,
                    projectStatusError: ''
                  }));
                }}
              >
                <MenuItem
                  style={{ display: 'none' }}
                  selected
                  disabled
                  value=""
                >
                  Select Project Status
                </MenuItem>
                {projectStatus?.map((stat) => (
                  <MenuItem value={stat.title}>{stat.title}</MenuItem>
                ))}
              </Select>
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px',
                  textTransform: 'capitalize'
                }}
                color="red"
              >
                {projectErrors.projectStatusError}
              </Typography>
            </Grid>
            {/* <Grid item xs={4} sx={{ pt: 3 }}>
              <Typography style={LabelStyle} fontWeight="light" variant="h5">
                Engagement Lead Type <span style={{ color: 'red' }}>*</span>
              </Typography>
              <Select
                id="create-leadResourceType"
                className="select-text"
                size="small"
                style={selectStyle}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                {...register('leadResourceType', {})}
                defaultValue={''}
                value={projectObj.leadResourceType}
                onChange={(e) => {
                  setProjectObj((prev) => ({
                    ...prev,
                    leadResourceType: e.target.value
                  }));
                  setProjectErrors((prev) => ({
                    ...prev,
                    leadResourceTypeError: ''
                  }));
                }}
              >
                <MenuItem
                  style={{ display: 'none' }}
                  selected
                  disabled
                  value=""
                >
                  Select Engagement Lead Type
                </MenuItem>
                <MenuItem value="Internal">Internal</MenuItem>
                <MenuItem value="External">External</MenuItem>
              </Select>

              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px',
                  textTransform: 'capitalize'
                }}
                color="red"
              >
                {projectErrors.leadResourceTypeError}
              </Typography>
            </Grid> */}
            {/* <Grid item xs={4} sx={{ pt: 3 }}>
              <Grid
                style={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <Typography style={LabelStyle} fontWeight="light" variant="h5">
                  Engagement Lead <span style={{ color: 'red' }}>*</span>
                </Typography>
                {projectObj.leadResourceType === 'External' && (
                  <Typography
                    id="toggleExternalsAdd"
                    onClick={() => toggleExternalsAdd()}
                    style={{
                      paddingLeft: 15,
                      paddingRight: 15,
                      fontSize: '11px',
                      color: '#0000EE',
                      cursor: 'pointer'
                    }}
                    fontWeight="light"
                    variant="h5"
                  >
                    Create External Lead
                  </Typography>
                )}
              </Grid>

              <Select
                id="create-leadResourceId"
                MenuProps={{ autoFocus: false }}
                labelId="search-select-label"
                disabled={projectObj.leadResourceType === ''}
                className="select-text"
                size="small"
                style={selectStyle}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                {...register('leadResourceId', {})}
                defaultValue={''}
                value={projectObj.leadResourceId || ''}
                onChange={(e) => {
                  if (projectObj.leadResourceType === 'External') {
                    const leadId = e.target.value;
                    const selectObj = externalLeads?.filter(
                      (lead) => lead.id === leadId
                    )[0];
                    const leadName = selectObj.name;
                    setProjectObj((prev) => ({
                      ...prev,
                      leadResourceId: leadId
                    }));
                    setProjectObj((prev) => ({
                      ...prev,
                      leadResourceName: leadName
                    }));
                  } else {
                    const empId = e.target.value;
                    const selectObj = employees?.filter(
                      (emp) => emp.id === empId
                    )[0];
                    const empName = selectObj.name;
                    setProjectObj((prev) => ({
                      ...prev,
                      leadResourceId: empId
                    }));
                    setProjectObj((prev) => ({
                      ...prev,
                      leadResourceName: empName
                    }));
                  }
                  setProjectErrors((prev) => ({
                    ...prev,
                    leadResourceNameError: ''
                  }));
                }}
                onClose={() => setSearchText('')}
              >
                <ListSubheader>
                  <TextField
                    id="search-create-leadResourceId"
                    size="small"
                    autoFocus
                    placeholder="Type to search..."
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      )
                    }}
                    onChange={(e) => setSearchText(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key !== 'Escape') {
                        e.stopPropagation();
                      }
                    }}
                  ></TextField>
                </ListSubheader>
                <MenuItem
                  style={{ display: 'none' }}
                  selected
                  disabled
                  value=""
                >
                  Select Engagement Lead
                </MenuItem>
                {projectObj.leadResourceType === 'Internal'
                  ? displayedEnagagementLead.length > 0 &&
                    displayedEnagagementLead?.map((option, i) => (
                      <MenuItem key={i} value={option.id}>
                        {option.name}
                      </MenuItem>
                    ))
                  : 
                  displayedEnagagementLeadExternal.length > 0 &&
                  displayedEnagagementLeadExternal?.map((option, i) => (
                      <MenuItem key={i} value={option.id}>
                        {option.name}
                      </MenuItem>
                    ))
                  // externalLeads?.map((ext) => (
                  //     <MenuItem key={ext?.id} value={ext.id}>
                  //       {ext.name}
                  //     </MenuItem>
                  //   ))
                    }
              </Select>
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px',
                  textTransform: 'capitalize'
                }}
                color="red"
              >
                {projectErrors.leadResourceNameError}
              </Typography>
            </Grid> */}
            <Grid item xs={4} sx={{ pt: 3 }}>
              <Typography style={LabelStyle} fontWeight="light" variant="h5">
                Project Lead <span style={{ color: 'red' }}>*</span>
              </Typography>
              <Select
                id="create-projectLeadId"
                MenuProps={{ autoFocus: false }}
                labelId="search-select-label"
                className="select-text"
                size="small"
                style={selectStyle}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                {...register('projectLeadId', {})}
                defaultValue={''}
                value={projectObj.projectLeadId || ''}
                onChange={(e) => {
                  setProjectObj((prev) => ({
                    ...prev,
                    projectLeadId: e.target.value
                  }));
                  setProjectErrors((prev) => ({
                    ...prev,
                    projectLeadIdError: ''
                  }));
                }}
                onClose={() => setSearchText('')}
              >
                <ListSubheader>
                  <TextField
                    id="search-create-projectLeadId"
                    size="small"
                    autoFocus
                    placeholder="Type to search..."
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      )
                    }}
                    onChange={(e) => setSearchText(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key !== 'Escape') {
                        e.stopPropagation();
                      }
                    }}
                  ></TextField>
                </ListSubheader>
                <MenuItem
                  style={{ display: 'none' }}
                  selected
                  disabled
                  value=""
                >
                  Select Project Lead
                </MenuItem>
                {displayedProductLead.length > 0 &&
                  displayedProductLead?.map((option, i) => (
                    <MenuItem key={i} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
              </Select>
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px',
                  textTransform: 'capitalize'
                }}
                color="red"
              >
                {projectErrors.projectLeadIdError}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{ pt: 3, pb: 1, pl: 4, pr: 4 }}>
            <Typography style={{ fontSize: '15px' }} variant="h3">
              Stakeholders
            </Typography>
          </Grid>
          <Grid container sx={{ pt: 2, pb: 1, pl: 2 }}>
            <Grid item xs={4}>
              <Grid
                style={{ display: 'flex', justifyContent: 'space-between' }}
              >
                <Typography style={LabelStyle} fontWeight="light" variant="h5">
                  Stakeholder Name <span style={{ color: 'red' }}>*</span>
                </Typography>
                <Typography
                  id="btn-toggleStakeholdersAdd"
                  onClick={() => {
                    toggleStakeholdersAdd();
                  }}
                  style={{
                    paddingLeft: 15,
                    paddingRight: 15,
                    fontSize: '11px',
                    color: '#0000EE',
                    cursor: 'pointer'
                  }}
                  fontWeight="light"
                  variant="h5"
                >
                  Create New Stakeholder
                </Typography>
              </Grid>
              <Select
                id="create-projectStakeHolders"
                MenuProps={{ autoFocus: false }}
                labelId="search-select-label"
                className="select-text"
                size="small"
                style={selectStyle}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                {...register('projectStakeHolders', {})}
                defaultValue={''}
                value={selectedStakeholder || ''}
                onChange={(e) => {
                  setSelectedStakeholder(e.target.value);
                  isSetStakeholderName(true);
                  setProjectStakeholderError('');
                }}
                onClose={() => setSearchText('')}
              >
                <ListSubheader>
                  <TextField
                    id="search-create-projectStakeHolders"
                    size="small"
                    autoFocus
                    placeholder="Type to search..."
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      )
                    }}
                    onChange={(e) => setSearchText(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key !== 'Escape') {
                        e.stopPropagation();
                      }
                    }}
                  ></TextField>
                </ListSubheader>
                <MenuItem
                  style={{ display: 'none' }}
                  selected
                  disabled
                  value={''}
                >
                  Select Stakeholder
                </MenuItem>
                {displayedStakeholderName?.length > 0 &&
                  displayedStakeholderName?.map((option, i) => (
                    <MenuItem key={i} value={option.id}>
                      {option.name}
                    </MenuItem>
                  ))}
              </Select>
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px',
                  textTransform: 'capitalize'
                }}
                color="red"
              >
                {projectStakeholderError}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography style={LabelStyle} fontWeight="light" variant="h5">
                Stakeholder Role <span style={{ color: 'red' }}>*</span>
              </Typography>
              <Select
                id="create-selectedRole"
                MenuProps={{ autoFocus: false }}
                labelId="search-select-label"
                className="select-text"
                size="small"
                style={selectStyle}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                defaultValue={''}
                value={selectedRole || ''}
                onChange={(e) => {
                  setSelectedRole(e.target.value);
                  isSetStakeholderRole(true);
                  setProjectStakeholderRoleError('');
                }}
                onClose={() => setSearchText('')}
              >
                <ListSubheader>
                  <TextField
                    id="search-create-selectedRole"
                    size="small"
                    autoFocus
                    placeholder="Type to search..."
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      )
                    }}
                    onChange={(e) => setSearchText(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key !== 'Escape') {
                        e.stopPropagation();
                      }
                    }}
                  ></TextField>
                </ListSubheader>
                <MenuItem
                  style={{ display: 'none' }}
                  selected
                  disabled
                  value={''}
                >
                  Select Stakeholder Role
                </MenuItem>
                {displayedStakeholderRole?.map((option, i) => (
                    <MenuItem key={i} value={option.id}>
                      {option.value}
                    </MenuItem>
                  ))}
              </Select>
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px',
                  textTransform: 'capitalize'
                }}
                color="red"
              >
                {projectStakeholderRoleError}
              </Typography>
            </Grid>
            <Grid item xs={4} sx={{ pt: 3 }}>
              <Button
                id="btn-setSelectedStakeholders"
                disabled={!(isStakeholderName && isStakeholderRole)}
                type="button"
                sx={{
                  ml: 2,
                  px: 4,
                  fontSize: '13px',
                  fontWeight: 'normal'
                }}
                variant="outlined"
                onClick={() => {
                  setStakeholderError('');
                  if (
                    projectObj.projectStakeHolders.some(
                      (sta) => sta.stakeholderId === selectedStakeholder
                    )
                  ) {
                    setProjectErrors((prev) => ({
                      ...prev,
                      stakeholderDuplicate: 'Duplicated stakeholders'
                    }));
                  } else if (
                    selectedStakeholder !== '' &&
                    selectedRole !== ''
                  ) {
                    setProjectErrors((prev) => ({
                      ...prev,
                      stakeholderDuplicate: ''
                    }));
                    const stakeholdersArr = [...projectObj.projectStakeHolders];
                    const stakeholdersArrLocal = [...selectedStakeholders];
                    const filteredStakeholder = stakeholders?.filter(
                      (stake) => stake.id === selectedStakeholder
                    )[0];

                    const filteredStakeholderRole = stakeholderRoles?.filter(
                      (stake) => stake.id === selectedRole
                    )[0];

                    const currentStakeholder = {
                      stakeholderId: filteredStakeholder.id,
                      stakeholderRoleId: filteredStakeholderRole.id,
                      stakeholderRoleName: filteredStakeholderRole.value
                    };
                    const currentStakeholderLocal = {
                      stakeholderId: filteredStakeholder.id,
                      stakeholderName: filteredStakeholder.name,
                      stakeholderRoleId: filteredStakeholderRole.id,
                      stakeholderRoleName: filteredStakeholderRole.value
                    };
                    stakeholdersArr.push(currentStakeholder);
                    stakeholdersArrLocal.push(currentStakeholderLocal);
                    setSelectedStakeholders([...stakeholdersArrLocal]);
                    setProjectObj((prev) => ({
                      ...prev,
                      projectStakeHolders: [...stakeholdersArr]
                    }));
                    setSelectedRole('');
                    setSelectedStakeholder('');
                  }
                }}
              >
                Add
              </Button>
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px',
                  textTransform: 'capitalize'
                }}
                color="red"
              >
                {projectErrors.stakeholderDuplicate}
                {stakeholderError}
              </Typography>
            </Grid>
            {projectObj?.projectStakeHolders?.length > 0 && (
              <Grid
                container
                sx={{
                  pt: 2,
                  pb: 1,
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                {selectedStakeholders?.map((stake, i) => (
                  <Grid item display="flex">
                    <Grid item xs={4} sx={{ pt: 2 }}>
                      <TextField
                        id={"stakeholderName" + i}
                        disabled
                        size="small"
                        style={TextFieldStyle}
                        fullWidth
                        placeholder="Enter Project Delivery Status"
                        variant="outlined"
                        className="input-text"
                        inputProps={{
                          style: {
                            height: '1.25rem',
                            fontSize: '13px'
                          }
                        }}
                        value={stake.stakeholderName}
                      />
                    </Grid>
                    <Grid item xs={4} sx={{ pt: 2 }}>
                      <TextField
                        id={"stakeholderRoleName" + i}
                        disabled
                        size="small"
                        style={TextFieldStyle}
                        fullWidth
                        placeholder="Enter Project Delivery Status"
                        variant="outlined"
                        className="input-text"
                        inputProps={{
                          style: {
                            height: '1.25rem',
                            fontSize: '13px'
                          }
                        }}
                        value={stake.stakeholderRoleName}
                      />
                    </Grid>
                    <Grid item xs={4} sx={{ pt: 3.5 }}>
                      <CancelIcon
                        id={"btn-removeStakeholder" + i}
                        style={{
                          color: 'gray',
                          fontSize: '1.25rem',
                          cursor: 'pointer'
                        }}
                        onClick={() => {
                          const stakeholdersArr = [
                            ...projectObj.projectStakeHolders
                          ];
                          const stakeholdersArrLocal = [
                            ...selectedStakeholders
                          ];
                          const filteredStakeholders = stakeholdersArr?.filter(
                            (st) => st.stakeholderId !== stake.stakeholderId
                          );
                          const filteredStakeholdersLocal =
                            stakeholdersArrLocal?.filter(
                              (st) => st.stakeholderId !== stake.stakeholderId
                            );
                          setSelectedStakeholders([
                            ...filteredStakeholdersLocal
                          ]);
                          setProjectObj((prev) => ({
                            ...prev,
                            projectStakeHolders: [...filteredStakeholders]
                          }));
                        }}
                      />
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            )}
          </Grid>
          <Grid item xs={12} sx={{ pt: 3, pb: 1, pl: 4, pr: 4 }}>
            <Typography style={{ fontSize: '15px' }} variant="h3">
              Financial Details
            </Typography>
          </Grid>
          <Grid container sx={{ pt: 2, pb: 1, pl: 2 }}>
            <Grid item xs={4}>
              <Typography style={LabelStyle} fontWeight="light" variant="h5">
              Billing Category{' '}
                <span style={{ color: 'red' }}>*</span>
              </Typography>
              <Select
                id="create-billingCategory"
                className="select-text"
                size="small"
                style={selectStyle}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                {...register('billingCategory', {})}
                defaultValue={''}
                value={projectObj.billingCategory}
                onChange={(e) => {
                  setProjectObj((prev) => ({
                    ...prev,
                    billingCategory: e.target.value
                  }));
                  setProjectErrors((prev) => ({
                    ...prev,
                    billingCategoryError: ''
                  }));
                }}
              >
                <MenuItem
                  style={{ display: 'none' }}
                  selected
                  disabled
                  value={''}
                >
                  Select Billing Category
                </MenuItem>
                {billingCategories?.map((bill) => {
                  return <MenuItem value={bill.title}>{bill.title}</MenuItem>;
                })}
              </Select>
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px',
                  textTransform: 'capitalize'
                }}
                color="red"
              >
                {projectErrors.billingCategoryError}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography style={LabelStyle} fontWeight="light" variant="h5">
                SOW / PO Status <span style={{ color: 'red' }}>*</span>
              </Typography>
              <Select
                id="create-sowStatus"
                className="select-text"
                size="small"
                style={selectStyle}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                {...register('sowStatus', {})}
                defaultValue={''}
                value={projectObj.sowStatus}
                onChange={(e) => {
                  setProjectObj((prev) => ({
                    ...prev,
                    sowStatus: e.target.value
                  }));
                  setProjectErrors((prev) => ({
                    ...prev,
                    sowStatusError: ''
                  }));
                }}
              >
                <MenuItem
                  style={{ display: 'none' }}
                  selected
                  disabled
                  value={''}
                >
                  Select SOW / PO Status
                </MenuItem>
                <MenuItem value="Approved">Approved</MenuItem>
                <MenuItem value="Raised">Raised</MenuItem>
                <MenuItem value="Not raised">Not raised</MenuItem>
                <MenuItem value="N/A">N/A</MenuItem>
              </Select>
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px',
                  textTransform: 'capitalize'
                }}
                color="red"
              >
                {projectErrors.sowStatusError}
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <Typography style={LabelStyle} fontWeight="light" variant="h5">
                PO Status <span style={{ color: 'red' }}>*</span>
              </Typography>
              <Select
                id="create-poStatus"
                className="select-text"
                size="small"
                style={selectStyle}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                {...register('poStatus', {})}
                defaultValue={''}
                onChange={(e) => {
                  setProjectObj((prev) => ({
                    ...prev,
                    poStatus: e.target.value
                  }));
                  setProjectErrors((prev) => ({
                    ...prev,
                    poStatusError: ''
                  }));
                }}
              >
                <MenuItem
                  style={{ display: 'none' }}
                  selected
                  disabled
                  value={''}
                >
                  Select PO Status
                </MenuItem>
                <MenuItem value="Received">Received</MenuItem>
                <MenuItem value="Not Received">Not Received</MenuItem>
              </Select>
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px',
                  textTransform: 'capitalize'
                }}
                color="red"
              >
                {projectErrors.poStatusError}
              </Typography>
            </Grid>
            <Grid item xs={4} sx={{ pt: 3 }}>
              <Typography style={LabelStyle} fontWeight="light" variant="h5">
                Note for Invoice
                <span style={{ fontSize: '10px', fontWeight: 'light' }}>
                  {'(Optional)'}
                </span>
              </Typography>
              <TextField
                id="create-noteForInvoice"
                size="small"
                multiline
                rows={3}
                className="input-text"
                style={TextFieldStyle}
                inputProps={{
                  style: {
                    fontSize: '13px'
                  }
                }}
                fullWidth
                placeholder="Enter Note for Invoice"
                variant="outlined"
                {...register('noteForInvoice', {})}
                value={projectObj.noteForInvoice}
                onChange={(e) => {
                  if (e.target.value.length > 100) {
                    setProjectErrors((prev) => ({
                      ...prev,
                      invoiceNoteError: 'Character length should not exceed 100'
                    }));
                  } else {
                    setProjectErrors((prev) => ({
                      ...prev,
                      invoiceNoteError: ''
                    }));
                  }
                  setProjectObj((prev) => ({
                    ...prev,
                    noteForInvoice: e.target.value
                  }));
                }}
              />
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px',
                  textTransform: 'capitalize'
                }}
                color="red"
              >
                {projectErrors.invoiceNoteError}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} sx={{ pt: 3, pb: 1, pl: 4, pr: 4 }}>
            <Typography style={{ fontSize: '15px' }} variant="h3">
              Time Estimation
            </Typography>
          </Grid>
          <Grid container sx={{ pt: 2, pb: 1, pl: 2 }}>
            <Grid item xs={4}>
              <Typography style={LabelStyle} fontWeight="light" variant="h5">
                Planned Hours<span style={{ color: 'red' }}>*</span>
              </Typography>
              <TextField
                id="create-plannedHours"
                size="small"
                fullWidth
                className="input-text"
                style={TextFieldStyle}
                placeholder="Enter Planned Hours"
                variant="outlined"
                inputProps={{
                  style: {
                    height: '1.25rem',
                    fontSize: '13px'
                  }
                }}
                type="text"
                {...register('plannedHours', {})}
                value={projectObj.plannedHours || ''}
                onChange={(e) => {
                  const regex = /^\d*$/;
                  if (
                    e.target.value.match(regex) &&
                    e.target.value.length <= 5
                  ) {
                    setProjectObj((prev) => ({
                      ...prev,
                      plannedHours: Number(e.target.value)
                    }));
                    setProjectErrors((prev) => ({
                      ...prev,
                      plannedHoursError: ''
                    }));
                  }
                }}
              />
              <Typography
                style={{
                  paddingLeft: 15,
                  paddingRight: 15,
                  fontSize: '11px',
                  textTransform: 'capitalize'
                }}
                color="red"
              >
                {projectErrors.plannedHoursError}
              </Typography>
            </Grid>
            {/* {projectObj.type === 'Delivery' && (
              <Grid item xs={4}>
                <Typography style={LabelStyle} fontWeight="light" variant="h5">
                  Revised Planned Hours<span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                  size="small"
                  fullWidth
                  className="input-text"
                  style={TextFieldStyle}
                  placeholder="Enter Revised Planned Hours"
                  variant="outlined"
                  inputProps={{
                    style: {
                      height: '1.25rem',
                      fontSize: '13px'
                    }
                  }}
                  type="number"
                  {...register('revisedPlannedHours', {})}
                  value={projectObj.revisedPlannedHours || ''}
                  onChange={(e) => {
                    const regex = /^\d*(\.\d+)?$/;
                    if (
                      e.target.value.match(regex) &&
                      e.target.value.length <= 5
                    ) {
                      setProjectObj((prev) => ({
                        ...prev,
                        revisedPlannedHours: Number(e.target.value)
                      }));
                      setProjectErrors((prev) => ({
                        ...prev,
                        revisedPlannedHoursError: ''
                      }));
                    }
                  }}
                />
                <Typography
                  style={{
                    paddingLeft: 15,
                    paddingRight: 15,
                    fontSize: '11px',
                    textTransform: 'capitalize'
                  }}
                  color="red"
                >
                  {projectErrors.revisedPlannedHoursError}
                </Typography>
              </Grid>
            )} */}
            {projectObj.type === 'Pre-sale' && (
              <Grid item xs={4}>
                <Typography style={LabelStyle} fontWeight="light" variant="h5">
                  Pre-sale Start Date<span style={{ color: 'red' }}>*</span>
                </Typography>
                <div style={{ marginRight: 5, marginTop: 5, marginLeft: 15 }}>
                  <FormControl fullWidth>
                    <DatePicker
                      InputProps={{
                        className: 'date-picker'
                      }}
                      renderInput={(params) => (
                        <TextField {...params} id="create-preSalesStartDate" />
                      )}
                      value={
                        projectObj?.preSalesStartDate
                          ? projectObj.preSalesStartDate
                          : ''
                      }
                      onChange={(newValue) => {
                        if (newValue) {
                          setProjectObj((prev) => ({
                            ...prev,
                            preSalesStartDate:
                              moment(newValue).format('YYYY-MM-DD')
                          }));
                          setProjectErrors((prev) => ({
                            ...prev,
                            preSalesStartDateError: ''
                          }));
                        }
                      }}
                    />
                  </FormControl>
                </div>
                <Typography
                  style={{
                    paddingLeft: 15,
                    paddingRight: 15,
                    fontSize: '11px',
                    textTransform: 'capitalize'
                  }}
                  color="red"
                >
                  {projectErrors.preSalesStartDateError}
                </Typography>
              </Grid>
            )}
            {projectObj.type === 'Pre-sale' && (
              <Grid item xs={4}>
                <Typography style={LabelStyle} fontWeight="light" variant="h5">
                  Pre-sale End Date<span style={{ color: 'red' }}>*</span>
                </Typography>
                <div style={{ marginRight: 5, marginTop: 5, marginLeft: 15 }}>
                  <FormControl fullWidth>
                    <DatePicker
                      disabled={!projectObj.preSalesStartDate}
                      InputProps={{
                        className: 'date-picker'
                      }}
                      minDate={new Date(projectObj.preSalesStartDate)}
                      renderInput={(params) => (
                        <TextField {...params} id="create-preSalesEndDate" />
                      )}
                      value={
                        projectObj?.preSalesEndDate
                          ? projectObj.preSalesEndDate
                          : ''
                      }
                      onChange={(newValue) => {
                        if (newValue) {
                          setProjectObj((prev) => ({
                            ...prev,
                            preSalesEndDate:
                              moment(newValue).format('YYYY-MM-DD')
                          }));
                          setProjectErrors((prev) => ({
                            ...prev,
                            preSalesEndDateError: ''
                          }));
                        }
                      }}
                    />
                  </FormControl>
                </div>
                <Typography
                  style={{
                    paddingLeft: 15,
                    paddingRight: 15,
                    fontSize: '11px',
                    textTransform: 'capitalize'
                  }}
                  color="red"
                >
                  {projectErrors.preSalesEndDateError}
                </Typography>
              </Grid>
            )}
            {projectObj.type === 'Delivery' && (
              <Grid item xs={4}>
                <Typography style={LabelStyle} fontWeight="light" variant="h5">
                  Planned Start Date<span style={{ color: 'red' }}>*</span>
                </Typography>
                <div style={{ marginRight: 5, marginTop: 5, marginLeft: 15 }}>
                  <FormControl fullWidth>
                    <DatePicker
                      InputProps={{
                        className: 'date-picker'
                      }}
                      renderInput={(params) => (
                        <TextField {...params} id="create-plannedStartDate" />
                      )}
                      value={
                        projectObj.plannedStartDate
                          ? projectObj.plannedStartDate
                          : ''
                      }
                      onChange={(newValue) => {
                        if (newValue) {
                          setProjectObj((prev) => ({
                            ...prev,
                            plannedStartDate:
                              moment(newValue).format('YYYY-MM-DD')
                          }));
                          setProjectErrors((prev) => ({
                            ...prev,
                            plannedStartDateError: ''
                          }));
                        }
                      }}
                    />
                  </FormControl>
                </div>
                <Typography
                  style={{
                    paddingLeft: 15,
                    paddingRight: 15,
                    fontSize: '11px',
                    textTransform: 'capitalize'
                  }}
                  color="red"
                >
                  {projectErrors.plannedStartDateError}
                </Typography>
              </Grid>
            )}
            {/* {projectObj.type === 'Delivery' && (
              <Grid item xs={4} sx={{ pt: 3 }}>
                <Typography style={LabelStyle} fontWeight="light" variant="h5">
                  Actual Start Date<span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                  className="date-text"
                  size="small"
                  variant="outlined"
                  fullWidth
                  placeholder="DD/MM/YYYY"
                  type="date"
                  defaultValue="2022-01-01"
                  InputLabelProps={{
                    shrink: false
                  }}
                  // InputProps={{
                  //   inputProps: {
                  //     min: moment(projectObj.plannedStartDate).format(
                  //       'YYYY-MM-DD'
                  //     )
                  //   }
                  // }}
                  style={TextFieldStyle}
                  inputProps={{
                    style: {
                      fontSize: '13px',
                      height: '1.25rem'
                    }
                  }}
                  {...register('actualStartDate', {})}
                  value={projectObj.actualStartDate}
                  onChange={(e) => {
                    setProjectObj((prev) => ({
                      ...prev,
                      actualStartDate: e.target.value
                    }));
                    setProjectErrors((prev) => ({
                      ...prev,
                      actualStartDateError: ''
                    }));
                  }}
                />
                <Typography
                  style={{
                    paddingLeft: 15,
                    paddingRight: 15,
                    fontSize: '11px',
                    textTransform: 'capitalize'
                  }}
                  color="red"
                >
                  {projectErrors.actualStartDateError}
                </Typography>
              </Grid>
            )} */}
            {projectObj.type === 'Delivery' && (
              <Grid item xs={4}>
                <Typography style={LabelStyle} fontWeight="light" variant="h5">
                  Planned End Date<span style={{ color: 'red' }}>*</span>
                </Typography>
                <div style={{ marginRight: 5, marginTop: 5, marginLeft: 15 }}>
                  <FormControl fullWidth>
                    <DatePicker
                      disabled={!projectObj.plannedStartDate}
                      InputProps={{
                        className: 'date-picker'
                      }}
                      minDate={new Date(projectObj.plannedStartDate)}
                      renderInput={(params) => (
                        <TextField {...params} id="create-plannedEndDate" />
                      )}
                      value={
                        projectObj?.plannedEndDate
                          ? projectObj.plannedEndDate
                          : ''
                      }
                      onChange={(newValue) => {
                        if (newValue) {
                          setProjectObj((prev) => ({
                            ...prev,
                            plannedEndDate:
                              moment(newValue).format('YYYY-MM-DD')
                          }));
                          setProjectErrors((prev) => ({
                            ...prev,
                            plannedEndDateError: ''
                          }));
                        }
                      }}
                    />
                  </FormControl>
                </div>
                <Typography
                  style={{
                    paddingLeft: 15,
                    paddingRight: 15,
                    fontSize: '11px',
                    textTransform: 'capitalize'
                  }}
                  color="red"
                >
                  {projectErrors.plannedEndDateError}
                </Typography>
              </Grid>
            )}
            {/* {projectObj.type === 'Delivery' && (
              <Grid item xs={4} sx={{ pt: 3 }}>
                <Typography style={LabelStyle} fontWeight="light" variant="h5">
                  Actual End Date<span style={{ color: 'red' }}>*</span>
                </Typography>
                <TextField
                  className="date-text"
                  size="small"
                  variant="outlined"
                  fullWidth
                  placeholder="DD/MM/YYYY"
                  type="date"
                  defaultValue="2022-01-01"
                  InputLabelProps={{
                    shrink: false
                  }}
                  InputProps={{
                    inputProps: {
                      min: moment(projectObj.actualStartDate).format(
                        'YYYY-MM-DD'
                      )
                    }
                  }}
                  style={TextFieldStyle}
                  inputProps={{
                    style: {
                      fontSize: '13px',
                      height: '1.25rem'
                    }
                  }}
                  {...register('actualEndDate', {})}
                  value={projectObj.actualEndDate}
                  onChange={(e) => {
                    setProjectObj((prev) => ({
                      ...prev,
                      actualEndDate: e.target.value
                    }));
                    setProjectErrors((prev) => ({
                      ...prev,
                      actualEndDateError: ''
                    }));
                  }}
                />
                <Typography
                  style={{
                    paddingLeft: 15,
                    paddingRight: 15,
                    fontSize: '11px',
                    textTransform: 'capitalize'
                  }}
                  color="red"
                >
                  {projectErrors.actualEndDateError}
                </Typography>
              </Grid>
            )} */}
          </Grid>
          <Grid container spacing={2} sx={{ pt: 1 }}>
            <Divider />
            <Grid
              item
              sx={{
                pr: 4,
                display: 'flex',
                justifyContent: 'flex-end'
              }}
              xs={12}
            >
              <Button
                id="btn-clearData"
                sx={{
                  px: 4,
                  fontWeight: 'normal',
                  background: '#F5F7FF',
                  fontSize: '13px'
                }}
                onClick={() => clearData()}
              >
                Cancel
              </Button>
              <Button
                id="btn-toggleConfirmation"
                disabled={isLoading}
                className={isLoading ? 'loading' : ''}
                type="button"
                sx={{
                  ml: 2,
                  px: 4,
                  fontSize: '13px',
                  fontWeight: 'normal',
                  background: '#0069E4'
                }}
                variant="contained"
                onClick={() => toggleConfirmation()}
              >
                Add
              </Button>
            </Grid>
          </Grid>
        </Card>
      </Container>
      <SnackBar
        snackBarOpen={snackBarOpen}
        setSnackBarOpen={setSnackBarOpen}
        snackBarMessage={snackBarMessage}
        snackbarSeverity={snackbarSeverity}
      />
      <ConfirmationModal
        isLoading={isLoading}
        open={openConfirmation}
        toggle={toggleConfirmation}
        message={`Are you sure you want to create a new project?`}
        onConfirm={() => onSubmit()}
        noToggle={toggleConfirmation}
      />
      <ToggleModalStakeholder
        open={openStakeHolders}
        toggle={toggleStakeholdersAdd}
        isEdit={false}
        getData={getStakeholderData}
        data={''}
        length={stakeholders.length}
        segments={segments}
        setSnackBarOpen={setSnackBarOpen}
        setSnackbarSeverity={setSnackbarSeverity}
        setSnackBarMessage={setSnackBarMessage}
      />
      <ToggleModalExternalsAdd
        open={openExternals}
        toggle={toggleExternalsAdd}
        getData={getAllExternalLeads}
        setSnackBarMessage={setSnackBarMessage}
        setSnackbarSeverity={setSnackbarSeverity}
        setSnackBarOpen={setSnackBarOpen}
      />
      <ToggleModalCustomer
        open={openCustomers}
        toggle={toggleCustomersAdd}
        isEdit={false}
        getData={getCustomerData}
        getSegmentData={getSegmentsCustomers}
        data={''}
        length={customers.length}
        segments={segments}
        countries={countries}
        setSnackBarOpen={setSnackBarOpen}
        setSnackbarSeverity={setSnackbarSeverity}
        setSnackBarMessage={setSnackBarMessage}
      />
    </Fragment>
  );
};

export default ProjectCreatePage;
